// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policy-page {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: var(--bg-white);
  overflow-y: auto;
  animation: policyPageIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes policyPageIn {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.policy-page__header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-soft);
}

.policy-page__header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
}

.policy-page__back {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-display);
  font-size: 14px;
  font-weight: 700;
  color: var(--text-dark);
  background: transparent;
}

.policy-page__back:hover {
  color: var(--teal-dark);
}

.policy-page__back-arrow {
  font-size: 16px;
}

.policy-page__eyebrow {
  font-family: var(--font-display);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--teal-dark);
  background: var(--teal-tint);
  padding: 6px 14px;
  border-radius: 100px;
}

.policy-page__tabbar {
  position: sticky;
  top: 68px;
  z-index: 1;
  background: var(--bg-white);
  border-bottom: 1px solid var(--border-soft);
}

.policy-page__tabbar-inner {
  display: flex;
  gap: 6px;
  overflow-x: auto;
}

.policy-page__tab {
  flex-shrink: 0;
  padding: 16px 16px 14px;
  font-family: var(--font-display);
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-grey);
  background: transparent;
  border-bottom: 2.5px solid transparent;
  white-space: nowrap;
}

.policy-page__tab--active {
  color: var(--teal-dark);
  border-bottom-color: var(--teal);
}

.policy-page__body {
  padding: 56px 24px 100px;
}

.policy-page__article {
  max-width: 720px;
  margin: 0 auto;
}

.policy-page__article h1 {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
}

.policy-page__updated {
  margin-top: 12px;
  font-size: 13px;
  color: var(--text-mute);
}

.policy-page__text {
  margin-top: 32px;
  white-space: pre-wrap;
  font-size: 15.5px;
  line-height: 1.9;
  color: var(--text-dark);
}

.policy-page__empty {
  margin-top: 32px;
  font-size: 15px;
  color: var(--text-grey);
}

.policy-page__fallback {
  margin-top: 32px;
  padding: 24px;
  border-radius: var(--radius-md);
  background: var(--bg-light);
  border: 1px solid var(--border-soft);
}

.policy-page__fallback p {
  font-size: 14px;
}

.policy-page__fallback-link {
  display: inline-block;
  margin-top: 12px;
  font-family: var(--font-display);
  font-size: 13.5px;
  font-weight: 700;
  color: var(--teal-dark);
}

.policy-page__fallback-link:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .policy-page__body {
    padding: 40px 20px 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PolicyModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".policy-page {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  background: var(--bg-white);\n  overflow-y: auto;\n  animation: policyPageIn 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes policyPageIn {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.policy-page__header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.policy-page__header-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 68px;\n}\n\n.policy-page__back {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--font-display);\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-dark);\n  background: transparent;\n}\n\n.policy-page__back:hover {\n  color: var(--teal-dark);\n}\n\n.policy-page__back-arrow {\n  font-size: 16px;\n}\n\n.policy-page__eyebrow {\n  font-family: var(--font-display);\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--teal-dark);\n  background: var(--teal-tint);\n  padding: 6px 14px;\n  border-radius: 100px;\n}\n\n.policy-page__tabbar {\n  position: sticky;\n  top: 68px;\n  z-index: 1;\n  background: var(--bg-white);\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.policy-page__tabbar-inner {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n}\n\n.policy-page__tab {\n  flex-shrink: 0;\n  padding: 16px 16px 14px;\n  font-family: var(--font-display);\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--text-grey);\n  background: transparent;\n  border-bottom: 2.5px solid transparent;\n  white-space: nowrap;\n}\n\n.policy-page__tab--active {\n  color: var(--teal-dark);\n  border-bottom-color: var(--teal);\n}\n\n.policy-page__body {\n  padding: 56px 24px 100px;\n}\n\n.policy-page__article {\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n.policy-page__article h1 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n}\n\n.policy-page__updated {\n  margin-top: 12px;\n  font-size: 13px;\n  color: var(--text-mute);\n}\n\n.policy-page__text {\n  margin-top: 32px;\n  white-space: pre-wrap;\n  font-size: 15.5px;\n  line-height: 1.9;\n  color: var(--text-dark);\n}\n\n.policy-page__empty {\n  margin-top: 32px;\n  font-size: 15px;\n  color: var(--text-grey);\n}\n\n.policy-page__fallback {\n  margin-top: 32px;\n  padding: 24px;\n  border-radius: var(--radius-md);\n  background: var(--bg-light);\n  border: 1px solid var(--border-soft);\n}\n\n.policy-page__fallback p {\n  font-size: 14px;\n}\n\n.policy-page__fallback-link {\n  display: inline-block;\n  margin-top: 12px;\n  font-family: var(--font-display);\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--teal-dark);\n}\n\n.policy-page__fallback-link:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 640px) {\n  .policy-page__body {\n    padding: 40px 20px 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
